<template>
  <div>
    <form>
    <div class="row pb-2">
        <div class="col-12">
            <strong>Title</strong>
            <input type="text" class="form-control" v-model="cat.title">
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <strong>Description</strong>
            <textarea v-model="cat.description" rows="5" class="form-control"></textarea>
        </div>
    </div>
    <div class="mt-4">
        <button type="submit" class="btn btn-info text-light" @click.prevent="create">
        {{ title }}
        </button>
    </div>
    </form>
  </div>
</template>
<script>
  export default {
    props: {
      catId: Number
    },
    data () {
      return {
        title : 'Create',
        cat: {
          title: '',
          description: '',
          sort: 0
        }
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      create () {
        var method = 'post';
        var host = this.$server + 'category';
        if (this.catId != 0) {
          method = 'put';
          host = this.$server + 'category/' + this.catId;
        }

        this.$axios({
          method: method,
          url: host,
          data: this.cat
        })
        .then(res => {
          var r = res.data;
          if (r.success) {
            this.$swal({
              title: r.message
            });
            this.$emit('callback', true);
          }
        });
      },
      init() {
        if (this.catId != 0) {
          this.title = 'Update';
          const me = this;
          this.$axios({
            method: 'get',
            url: this.$server + 'category/' + this.catId
          })
          .then(res => {
            var r = res.data;
            if (r.success) {
              me.cat = r.data[0];
            }
          });
        }
        this.$emit('callback', this.title);
      }
    }
  }

</script>
